import React from "react";
import { useSelector } from "react-redux";

import { getAuthenticationContext } from "@utils/configuration/aem";

import { SoftLoginService } from "@services/softLogin.service";

import { APIStatus, logout } from "@redux/modules/api/data/customer/customer.module";
import { getCustomer } from "@redux/modules/api/data/customer/customer.selectors";
import { useThunkDispatch } from "@redux/dispatcher";

import LogoutLink from "./logoutLink.component";

type Props = {
    classes?: string;
};

const LogoutLinkContainer = ({ classes }: Props) => {
    const dispatch = useThunkDispatch();
    const customer = useSelector(getCustomer);

    const handleLogout = () => {
        if (customer) {
            dispatch(logout()).then(action => {
                if (action.type === APIStatus.SUCCESS) {
                    location.assign(
                        getAuthenticationContext().loginPageUrl +
                            "?logoutsuccess=true",
                    );
                }
            });
        } else {
            SoftLoginService.clearSoftLogin();
            location.assign(getAuthenticationContext().loginPageUrl);
        }
    };

    return <LogoutLink classes={classes} logout={handleLogout} />;
};

export { LogoutLinkContainer };
